import { datadogRum } from '@datadog/browser-rum';
import { apiCallsStore } from '@store/api/store';
import { ConfigManager } from '@utils/ConfigManager';

export type FeedbackContextT = {
  currentUrl: string;
  rumSessionId: string;
  appVersion: string;
  apiCalls: string[];
};

export const collectFeedbackContext = (): FeedbackContextT => {
  let rumSessionId = '';
  try {
    rumSessionId = datadogRum.getInternalContext()?.session_id ?? '';
  } catch {
    rumSessionId = '';
  }

  return {
    currentUrl: window.location.href,
    rumSessionId,
    appVersion: ConfigManager.appVersion,
    apiCalls: apiCallsStore.apiCalls.map(
      (call) =>
        `Url: ${call.url}, Method: ${call.method}, StatusCode: ${call.status}, Time: ${call.timeStamp}`,
    ),
  };
};
